/* Copyright (c) 2017 Backpack Health LLC */
import PropTypes from 'prop-types';

enum ShareCardIncludedTypeNames {
  all = 'all',
  latest = 'latest',
}

export const ShareCardIncludedTypeNamesPropType = PropTypes.oneOf([
  ShareCardIncludedTypeNames.all,
  ShareCardIncludedTypeNames.latest,
]);

export default ShareCardIncludedTypeNames;
